function getProp(path: string | (string | number)[] | undefined, object: unknown): unknown {
  const keys = Array.isArray(path) ? path : path?.split('.');

  return keys?.reduce<unknown>((inputObj, key) => {
    if (!inputObj) return null;
    const value: unknown = Reflect.get(Object(inputObj), key);
    if (value === undefined) return null;
    return value;
  }, object);
}

export default getProp;
